import { render, staticRenderFns } from "./CardPlans.vue?vue&type=template&id=08045528"
import script from "./CardPlans.vue?vue&type=script&lang=js"
export * from "./CardPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08045528')) {
      api.createRecord('08045528', component.options)
    } else {
      api.reload('08045528', component.options)
    }
    module.hot.accept("./CardPlans.vue?vue&type=template&id=08045528", function () {
      api.rerender('08045528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/Cards/CardPlans.vue"
export default component.exports